import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ErrorService } from 'src/app/core/services/error.service';
import { castToDateAttribute } from 'src/app/shared/functions/date.functions';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLuxonDateModule, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatInputModule } from '@angular/material/input';
import { MyDatetimeFormat } from './models/datetime-format.model';
import { DialogService } from 'src/app/core/services/dialog.service';
import { GetTimeComponent } from '../../dialogs/get-time/get-time.component';
import { DateTime } from 'luxon';
@Component({
  selector: 'app-input-datetime',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatLuxonDateModule
  ],
  providers: [
    MatDatepickerModule,
    provideLuxonDateAdapter(MyDatetimeFormat)
  ],
  templateUrl: './input-datetime.component.html',
  styleUrl: './input-datetime.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputDatetimeComponent {
  @Input() name: string = '';
  @Input() label: string = 'Data e ora';
  @Input() icon?: string;
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;
  @Input() class: string = '';
  @Input({
    transform: castToDateAttribute,
  }) minDate?: Date;
  @Input({
    transform: castToDateAttribute,
  }) maxDate?: Date;
  @Input({
    transform: booleanAttribute,
  }) showSeconds: boolean = false;

  constructor(
    private errorService: ErrorService,
    private dialogService: DialogService,
  ) { }

  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.name, errors);
  }

  onChange(event: any) {
    if (event.value !== null) {
      this.openGetTimeDialog();
    }
  }
  openGetTimeDialog(): void {
    const dialogRef = this.dialogService.open(GetTimeComponent, {
      data: {
        showSeconds: this.showSeconds
      }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Recupera la data attuale selezionata dal form e convertila usando Luxon
        let datetime = DateTime.fromJSDate(new Date(this.form.get(this.name)?.value));
  
        // Setta ore, minuti e secondi
        datetime = datetime.set({
          hour: result.hours,
          minute: result.minutes,
          second: result.seconds
        });
  
        // Imposta il fuso orario corretto
        const timezoneOffset = (datetime.month >= 3 && datetime.month <= 10) ? '+02:00' : '+01:00';  // Verifica se è in ora legale
        datetime = datetime.setZone(timezoneOffset);
  
        this.form.get(this.name)?.setValue(datetime.toISO());  // Setta la data nel form
      }
    });
  }
}
